import {effect, OnChanges, OnInit, signal, SimpleChanges} from "@angular/core";
import {SectionModel} from "@white-label/components/page-builder/models/section.model";

export class PageBuilderStore {
    private _componentData = signal<any>(null);
    private _index = signal<any>(null);
    private _sideBarIsOpen = signal<boolean>(true);
    public _sectionData = signal<SectionModel | null>(null);
    private _page = signal<any>(null);
    private _configurationTab = signal<string>('ai-builder');


    constructor() {
        effect(() => {
            const sectionData = this._sectionData();
            if (sectionData) {
                console.log('Section Data changed:', sectionData.px);

                // Watch specific property: enableContainer
                if (sectionData.enableContainer !== undefined) {
                    console.log('enableContainer changed:', sectionData.enableContainer);
                }
            }
        });
    }

    get componentData(){
        return this._componentData();
    }

    set componentData(value: any) {
        this._componentData.set(value);
    }

    get index(){
        return this._index();
    }

    set index(value: any) {
        this._index.set(value);
    }


    get page(){
        return this._page();
    }

    set page(value: any) {
        this._page.set(value);
    }

    get sectionData(){
        return this._sectionData();
    }

    set sectionData(value: any) {
        console.log('value', value)
        this._sectionData.set(value);
    }

    get configurationTab(){
        return this._configurationTab();
    }

    set configurationTab(value: any) {
        this._configurationTab.set(value);
    }

    get sideBarIsOpen(){
        return this._sideBarIsOpen();
    }

    set sideBarIsOpen(value: any) {
        this._sideBarIsOpen.set(value);
    }


}